import CsBreadCrumb from './CsBreadCrumb.vue'
CsBreadCrumb.install = function (Vue) {
  Vue.component(CsBreadCrumb.name, CsBreadCrumb)
}
export default CsBreadCrumb


// WEBPACK FOOTER //
// ./src/components/breadcrumb/index.js